import { createFileRoute, redirect } from '@tanstack/react-router';
import { UserProfilePreview } from '../components/UserProfilePreview';
import { Pane } from '@sheridan-prize/ui';
import { UserProfileHeader } from '../components/UserProfileHeader';

export const Route = createFileRoute('/profiles_/$userId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();

  return (
    <>
      <UserProfileHeader />
      <div className="app">
        <Pane tag="main" classes={'sp-main sp-wide'}>
          <UserProfilePreview userId={userId} />
        </Pane>
      </div>
    </>
  );
}
